<template>
  <div class="pageview">
    <!-- <van-nav-bar title="社区服务" fixed /> -->
    <!-- banner切换 -->
    <div class="homeban">
      <van-swipe class="homebanner" :autoplay="3000" indicator-color="white">
        <van-swipe-item v-for="banner in bannerImgs" :key="banner.index"><img :src="banner"/></van-swipe-item>
      </van-swipe>
    </div>
    <!-- <h3 class="grouptitle">助企助商服务平台</h3> -->
    <van-grid class="wktype" :border="false" :column-num="5">
      <van-grid-item icon="photo-o" @click="gotoUrl('/home/dynamic')">
        <van-image class="iconimg" :src="require('../../assets/业界动态.png')"></van-image>
        <span class="wktext">业界动态</span>
      </van-grid-item>
      <van-grid-item icon="photo-o" @click="gotoUrl('/home/huayang')">
        <van-image class="iconimg" :src="require('../../assets/中介超市.png')"></van-image>
        <span class="wktext">中介超市</span>
      </van-grid-item>
      <van-grid-item icon="photo-o" @click="gotoUrl('/home/serve')">
        <van-image class="iconimg" :src="require('../../assets/资源看板.png')"></van-image>
        <span class="wktext">资源看板</span>
      </van-grid-item>
      <van-grid-item icon="photo-o" @click="gotoUrl('/home/classroom')">
        <van-image class="iconimg" :src="require('../../assets/知识讲堂.png')"></van-image>
        <span class="wktext">知识讲堂</span>
      </van-grid-item>
      <van-grid-item icon="photo-o" @click="gotominiProgram()">
        <van-image class="iconimg" :src="require('../../assets/人资圈.png')"></van-image>
        <span class="wktext">人资圈</span>
      </van-grid-item>
      <!-- <template>
        <van-grid-item icon="photo-o" @click="gotoUrl('/home/interaction')">
          <van-image class="iconimg" :src="require('../../assets/hudong.png')"></van-image>
          <span class="wktext">政企互动</span>
        </van-grid-item>
      </template>   
      <template>
        <van-grid-item icon="photo-o" @click="gotoUrl('/list')">
          <van-image class="iconimg" :src="require('../../assets/招聘.png')"></van-image>
          <span class="wktext">求职招聘</span>
        </van-grid-item>
      </template> -->
    </van-grid>
    <div class="boxContent">
      <div class="boxContent1" @click="gotoUrl('/home/interaction')">
        <div>
          <div>政企互动</div>
          <div class="boxContent-en">interaction</div>
        </div>
        <div><img src="../../assets/政企互动.png" alt="" /></div>
      </div>
      <div class="boxContent2" @click="gotoUrl('/list')">
        <div>
          <div>求职招聘</div>
          <div class="boxContent-en">recruit</div>
        </div>
        <div><img src="../../assets/求职招聘.png" alt="" /></div>
      </div>
    </div>
    <!-- <h3 class="grouptitle">
      业界动态
      <router-link to="/home/dynamic" class="more">
        <span>更多<van-icon name="arrow"/></span>
      </router-link>
    </h3>
    <div class="information">
      <van-swipe class="my-swipe" :autoplay="99999999999" indicator-color="white">
        <van-swipe-item v-for="item in NoticeList" :key="item.index">
          <div class="center">
            <div @click="gotoUrl('/home/classroom/particulars/' + item.RIId)">
              <div class="centerTitle van-ellipsis">{{ item.Title }}</div>
              <div class="Content">
                <div style="display: inline-block" class="ContentA" v-if="item.Thematic">
                  <img :src="item.Thematic" alt="" @error="handleImageError" />
                </div>
                <div style="display: inline-block" class="ContentB">
                  <span class="van-multi-ellipsis--l3">{{ item.Summary }}</span>
                  <br />
                  <span class="centertime">{{ item.IssTime }}</span>
                </div>
              </div>
            </div>
          </div>
        </van-swipe-item>
      </van-swipe>
      <van-empty description="暂无动态" v-if="!NoticeList.length" />
    </div> -->
    <div class="contentBg"></div>
    <div style="padding-bottom: 5px;">
      <!-- <h3 class="grouptitle">
        企业资讯<router-link to="/home/introduce" class="more">
          <span>更多<van-icon name="arrow"/></span>
        </router-link>
      </h3> -->
      <div class="grouptitle">
        <div class="grouptitle-title">企业资讯</div>

        <!-- <router-link to="/home/introduce" class="more">
          <span>更多<van-icon name="arrow"/></span>
        </router-link> -->
      </div>
      <van-list :loading="loading" :finished="finished" finished-text="没有更多了"  offset="20" :immediate-check="false"
  @load="onLoad">
      <div class="information">
        <div class="my-swipe" :autoplay="99999999999" indicator-color="white">
          <div v-for="item in NoticeLists" :key="item.index">
            <div class="center">
              <div @click="gotoUrl('/home/classroom/particulars/' + item.id)">
                <!-- <div class="centerTitle van-ellipsis">{{ item.Title }}</div> -->
                <div class="Content">
                  <div style="display: inline-block" class="ContentA" v-if="item.img">
                    <img  :src="item.img.split(',')[0]" alt="" @error="handleImageError"  style="height: 70px; object-fit: cover; display: block" />
                  </div>
                 <div style="display: inline-block" class="ContentA" v-else>
                  <img
                    src="https://new-zhsq.oss-cn-beijing.aliyuncs.com/goodsImg/cdb4.png"
                    alt=""
                    style="height: 70px; object-fit: cover; display: block"
                  />
                 </div>
                  <div style="display: inline-block" class="ContentB">
                    <div class="centerTitle van-ellipsis" style="margin-bottom: 3px;">{{ item.title }}</div>
                    <span class="van-multi-ellipsis--l2" >{{item.overview}}</span>
                    <br />
                    <span class="centertime">{{ item.CreateTime }}</span>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <!-- <van-swipe class="my-swipe" :autoplay="99999999999" indicator-color="white">
          <van-swipe-item v-for="item in NoticeLists" :key="item.index">
            <div class="center">
              <div @click="gotoUrl('/home/classroom/particulars/' + item.id)">
                <div class="centerTitle van-ellipsis">{{ item.Title }}</div>
                <div class="Content">
                  <div style="display: inline-block" class="ContentA" v-if="item.img">
                    <img  :src="item.img.split(',')[0]" alt="" @error="handleImageError" />
                  </div>
                  <div style="display: inline-block" class="ContentB">
                    <div class="centerTitle van-ellipsis" style="margin-bottom: 3px;">{{ item.title }}</div>
                    <span class="van-multi-ellipsis--l2" >{{item.overview}}</span>
                    <br />
                    <span class="centertime">{{ item.CreateTime }}</span>
                  </div>
                </div>
              </div>
            </div>
          </van-swipe-item>
        </van-swipe> -->
        <!-- <van-empty description="暂无资讯" v-if="!NoticeLists.length" /> -->
      </div>
      <van-button v-if="showBtn" @click="backTop" class="backTop"
            ><img
              src="https://dximg.dexian.ren/lczhsq/top.png"
              style="width: 13px; vertical-align: middle"
              alt=""
          /></van-button>
    </van-list>
    </div>
    <!-- 登录按钮 -->
    <!-- <div class="flexOn" @click="onClickRight()">企业登录</div> -->
  </div>
</template>

<script>
import config from '@/config/index'
// import { mapGetters } from 'vuex'
import { WeGetEntElementPage, WeGetGoodNewsPage } from '@/api/Hyapi'
import { WeGetRealInfoPage } from '@/api/RealInfo'
import { WeGetAppletInfo } from '@/api/index'
// import TipsMiniProject from "@/components/TipsMiniProject";
// import Tabbar from "@/components/Tabbar";
import axios from 'axios'
import { setOpenId, getOpenId, getaccToken, setaccToken } from '@/utils/auth'

export default {
  // computed: {
  //   ...mapGetters([
  //     'openId',
  //   ])
  // },
  components: {
    // Tabbar,
    // TipsMiniProject,
  },
  data() {
    return {
      appInfo: {},
      bannerImgs: [
        'https://lycaljdapi.dexian.ren//upload/images/2024/1/642f1da9-136.jpg',
        'https://lycaljdapi.dexian.ren//upload/images/2024/1/2fc7500f-d77.jpg',
      ],
      active: 0,
      NoticeList: [],
      NoticeLists: [],
      area: '',
      AgencyFrom: {
        page: 1,
        limit: 5,
      },
      listfrom: {
        page: 1,
        limit: 5,
      }, //查询传参
      AgencyList: [],
      arrimg: [],
      defaultImageUrl: 'https://new-zhsq.oss-cn-beijing.aliyuncs.com/goodsImg/cb59.png', // 替换为你的默认图片链接
      loading: false, //加载
      finished: false, //数据完全加载结束为 true
      showBtn: false,
    }
  },
  mounted() {
    window.addEventListener("scroll", this.handleScroll);
    window.addEventListener("scroll", this.showBtnF, true);
  },
  created() {
    // this.getAppInfo()
    // 获取并保存openid
    if (this.$route.query['openid']) {
      // this.$store.dispatch('user/setopenid', { openid: this.$route.query['openid'] })
      setOpenId(this.$route.query['openid'])
    }
    this.area = config.area
    // this.getNoticeList()
    this.getNoticeLists()

    this.$WexinShare(location.href, {
      title: '欢迎来到吉利华阳',
    })
  },
  methods: {
    handleImageError(event) {
      event.target.src = this.defaultImageUrl
    },
    // 跳转登录
    onClickRight() {
      if (getaccToken() != undefined) {
        this.$router.push({ name: 'firm' })
      } else {
        this.$router.push('/huayang/firmlogin')
      }
    },
    //跳转到公共页面
    gotoUrl(path) {
      if (window.__wxjs_environment === 'miniprogram') {
        window.wx.miniProgram.navigateTo({
          url: '../public/goto?path=' + path,
        })
      } else {
        this.$router.push(path)
      }
    },
    //小程序跳转到小程序
    gotominiProgram() {
      if (window.__wxjs_environment === 'miniprogram') {
        window.wx.miniProgram.navigateTo({
          url: '../message/index',
        })
      } else {
        alert('请在小程序中打开')
      }
    },
    // 业界动态
    getNoticeList() {
      // 分享
      // console.log(this);
      // fenxiang(this.location.href);
      // fenxiang("http://172.18.1.229:8080/");
      this.listfrom.PAKind = 8
      WeGetGoodNewsPage(this.listfrom).then((res) => {
        this.NoticeList = res.data.data
      })
    },
    // 园区资讯
    getNoticeLists() {
      this.listfrom.PAKind = 9
      WeGetGoodNewsPage(this.listfrom).then((res) => {
        this.loading = false;
        if(res.data.code==0){
          let rows = res.data.data; //请求返回当页的列表
          // 加载状态结束
          if (rows == null || rows.length === 0) {
            // 加载结束
            console.log("结束");
            this.finished = true;
            return;
          }
           // 将新数据与老数据进行合并 concat合并数组
          this.NoticeLists = this.NoticeLists.concat(rows);
          //如果列表数据条数>=总条数，不再触发滚动加载
          if (this.NoticeLists.length >= res.data.count) {
            this.finished = true;
          }
        }else{
          this.finished = true;
        }
      })
    },
    // 小程序展示数据
    getAppInfo() {
      WeGetAppletInfo().then((res) => {
        var list = res.data
        if (list.code == 0) {
          var imgs = []
          imgs[0] = list.data.SysPic1Url
          imgs[1] = list.data.SysPic2Url
          imgs[2] = list.data.SysPic3Url
          this.bannerImgs = imgs
          this.appInfo = list.data
        }
      })
    },
    // 资源看板
    // GetAgencyPage() {
    //   WeGetEntElementPage(this.AgencyFrom).then((res) => {
    //     this.AgencyList = res.data.data;
    //     for (let i = 0; i < this.AgencyList.length; i++) {
    //       this.AgencyList[i].IssueTime = this.dataFormat(
    //         this.AgencyList[i].IssueTime
    //       );
    //     }
    //   });
    // },
    // 时间格式化
    // 时间格式化
    dataFormat(value) {
      var year = value.substr(0, 4)
      var month = value.substr(5, 2)
      var day = value.substr(8, 2)
      var hour = value.substr(11, 2)
      var min = value.substr(14, 2)
      var second = value.substr(17, 2)
      return year + '-' + month + '-' + day + ' ' + hour + ':' + min + ':' + second
    },

    // 上拉加载需要的函数
    onLoad() {
      console.log("asdsad");
      this.listfrom.page = this.listfrom.page+1 ;
      this.loading = true;
      this.getNoticeLists();
    },
    backTop() {
      // 开个定时器返回顶部时缓慢优雅一些，是 document.body.scrollTop = 0 的升级版
      const timer = setInterval(() => {
        // 页面顶部卷去高度
        let scrollTop =
          document.body.scrollTop || document.documentElement.scrollTop;
        console.log(scrollTop, "scrollTop");
        // 高度控速 = 页面顶部卷去高度正值 / n ===> n 越大，返回越慢
        let ispeed = Math.floor(-scrollTop / 5);
        console.log(scrollTop, "scrollTop");
        console.log(ispeed, "ispeed");
        // 页面顶部卷去高度 + 高度控速 ===> 和不为零，定时器一直开启（不明白的同志可以尝试同时打印 scrollTop 和 ispeed）
        document.body.scrollTop = scrollTop + ispeed;
        document.documentElement.scrollTop = scrollTop + ispeed;
        // 页面顶部卷去高度 + 高度控速 ===> 和为零返回顶部，清除定时器
        if (scrollTop === 0) {
          clearInterval(timer);
        }
      }, 20);
    },
    showBtnF() {
      let scrollTop =
        document.body.scrollTop || document.documentElement.scrollTop;
      if (scrollTop > 100) {
        this.showBtn = true;
      } else {
        this.showBtn = false;
      }
    },
  },
}
</script>

<style scoped>
.pageview {
  background-color: #ffffff;
  height: 100%;
}
.homeban {
  padding-top: 10px;
  background: linear-gradient(0deg, #ffffff, #4ecebc);
}
.homebanner img {
  width: 96%;
  margin: 0 2%;
  vertical-align: top;
  border-radius: 5px;
}
.wktime {
  padding: 0 20px;
}
.wktype {
  margin: 10px 0px;
}
/deep/ .van-grid-item__content {
  background: #ffffff !important;
}
.wktype .van-grid-item {
  background: #ffffff;
}
.orginview .iconimg {
  width: 62%;
}
.orginview .linktext {
  font-size: 14px;
  margin-top: 10px;
}
.wktype .iconimg {
  width: 65%;
}
.wktype .wktext {
  margin-top: 10px;
  font-size: 12px;
}
.grouptitle {
  /* border-left: 4px solid #e8060b; */
  text-indent: 15px;
  font-weight: normal;
  font-size: 15px;
  margin: 12px 0px 0 0px;
  color: #000;
  display: flex;
  justify-content: space-between;
}
.grouptitle-title {
  font-size: 16px;
  font-weight: bold;
}
.center {
  background: #fff;
  /* width: 82%; */
  margin: 0px 3% 15px;
  margin-bottom: 5px;
  border-radius: 10px;
  /* box-shadow: 1px 1px 5px #e6e6e6; */
}
.brakline {
  height: 5px;
  width: 100%;
  background: #eee;
  display: block;
}
.swipeBox {
  position: relative;
  width: 90%;
  padding: 5px 0;
  margin: 0px 5%;
  padding-bottom: 30px;
  background: #fff;
  border-radius: 10px;
  margin-bottom: 30px;
  box-shadow: 1px 1px 5px #e6e6e6;
}
.swipeBox div:nth-child(1) {
  padding-left: 15px;
  color: #000;
}
.swipeBox .contains {
  display: flex;
  width: 100%;
  font-size: 14px;
  margin: 5px 15px;
}
.contains span {
  color: #333;
  width: 75%;
}
.swipeBox .iconNew {
  position: absolute;
  top: 0px;
  right: 10px;
}
.swipeBox .iconPhone {
  position: absolute;
  top: 70px;
  right: 15px;
}
.flexOn {
  z-index: 10;
  right: 15px;
  bottom: 30px;
  position: fixed;
  width: 75px;
  height: 75px;
  line-height: 75px;
  background: #2196f3;
  border-radius: 15px;
  color: #fff;
  text-align: center;
  font-size: 14px;
}
.more span {
  float: right;
  /* margin-right: 30px; */
  font-size: 12px;
  color: #999999;
}
.more span .van-icon {
  top: 2px;
  right: 25px;
}
.wktype .van-grid-item {
  background: #ffffff;
}
.boxContent {
  font-family: PingFang SC;
  font-weight: 600;
  font-size: 16px;
  display: flex;
  justify-content: space-between;
  margin: 0 4%;
}
.contentBg {
  margin-top: 15px;
  border-bottom: 10px solid #f9f9fb;
}
.boxContent1 {
  background-color: #fef3f0;
  color: #f8947a;
  border-radius: 5px;
  width: 45%;
  padding: 10px 7px;
  display: flex;
  justify-content: space-around;
  align-items: center;
}
.boxContent1 img {
  width: 50px;
  height: 50px;
}
.boxContent2 {
  background-color: #e9f7ff;
  color: #64c5fd;
  border-radius: 5px;
  width: 45%;
  padding: 10px 7px;
  display: flex;
  justify-content: space-around;
  align-items: center;
}
.boxContent2 img {
  width: 50px;
  height: 50px;
}
.boxContent-en {
  font-weight: 500;
  font-size: 14px;
}
.backTop {
  position: fixed;
  bottom: 40px;
  right: 17px;
  width: 35px;
  height: 35px;
  background: rgba(255, 255, 255, 0.68);
  box-shadow: 0px 0px 3px 0px rgba(0, 0, 0, 0.06);
  border-radius: 50%;
}
</style>
